import appConstants from '~/libs/constants/application-constants.js'

const { nuxtBaseUrl } = appConstants

export function cleanOldRedirectPath(url) {
    if (!url) return url
    const str = Array.isArray(url) ? url[0] : url
    if (!str) return str
    const normalized = str.replace(/^\/\/+/, '/')
    // Strip the base URL prefix from legacy redirect values to prevent double-prefixing (/bp/bp/...)
    if (normalized.startsWith(`${nuxtBaseUrl}/`) || normalized.startsWith(`${nuxtBaseUrl}?`) || normalized.startsWith(`${nuxtBaseUrl}#`)) {
        const stripped = normalized.slice(nuxtBaseUrl.length)
        // Ensure base-root redirects (/bp?foo, /bp#hash) stay absolute
        if (stripped.startsWith('?') || stripped.startsWith('#')) return '/' + stripped
        return stripped || '/'
    }
    if (normalized === nuxtBaseUrl) {
        return '/'
    }
    // Handle relative paths with bp/ prefix (no leading slash)
    const baseSegment = nuxtBaseUrl.replace(/^\//, '')
    if (normalized.startsWith(`${baseSegment}/`) || normalized.startsWith(`${baseSegment}?`) || normalized.startsWith(`${baseSegment}#`)) {
        const stripped = normalized.slice(baseSegment.length)
        if (stripped.startsWith('?') || stripped.startsWith('#')) return '/' + stripped
        return stripped || '/'
    }
    if (normalized === baseSegment) {
        return '/'
    }
    return normalized
}
